import { ThunkAction, ThunkDispatch } from "redux-thunk";
import * as storeTypes from "../storeTypes";
import * as storeActions from "../storeActions";
import * as logService from "../../services/logService";
import { handleApiError } from "../storeEffects";
import { LogAction, logFailure, logSuccess } from "./storeLog";

export type LogThunkDispatch = ThunkDispatch<storeTypes.IApplicationState, null, LogAction>

export const getLogPage = (): ThunkAction<any, storeTypes.IApplicationState, any, any> => (dispatch, getState) => {
    dispatch(storeActions.fetchStart());
    return logService.getLogPage()
        .then(
            logPage => {
                dispatch(logSuccess(logPage));
            },
            error => {
                handleApiError(error, dispatch);
                dispatch(logFailure());
            })
        .finally(() =>
            dispatch(storeActions.fetchEnd())
        );
};